"use client"

import { ThemeProvider } from "next-themes"
import { PostHogProvider } from "@/lib/posthog"

export function Providers({ children }: { children: React.ReactNode }) {
  return (
    <PostHogProvider>
      <ThemeProvider attribute="class" defaultTheme="light" enableSystem={false}>
        {children}
      </ThemeProvider>
    </PostHogProvider>
  )
}
